// extracted by mini-css-extract-plugin
export default {"container":"SignIn_container__2e4d+","nameAndLocation":"SignIn_nameAndLocation__IF8D+"};